//BASIC DATA OBJECT FOR INITIALIZING THE APP
//real data will overwrite this when loaded with maestro
export const baseData = {
    global: {
        label: {
            next: '',
            submit: ''
        },
        options: {
            community: 'en'
        }
    },
    steps: [
        { type: 'card', title: '', number: 1, disabled: false },
        { type: 'birth-date', title: '', number: 1 },
        { type: 'card', title: '', number: 2 },
        { type: 'gender', title: '', number: 2 },
        { type: 'card', title: '', number: 3 },
        { type: 'name', title: '', number: 3 },
        { type: 'card', title: '', number: 4 }
    ]
};
